import {BusinessIndustry, BusinessIndustryMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableBusinessIndustryProps {
	businessIndustry?: BusinessIndustry
	setBusinessIndustry: (value: BusinessIndustry) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: BusinessIndustry) => void
	className?: string
}

export function EditableBusinessIndustryField(props: EditableBusinessIndustryProps) {
	if (props.businessIndustry) {
		return (
			<Editable
				label="Business Industry"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setBusinessIndustry}
				value={props.businessIndustry}
				initial={props.businessIndustry}
				update={props.update}
				className={props.className}
				possibleValues={BusinessIndustryMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
